import React from "react";
import {PayloadAction} from '@reduxjs/toolkit';
import {AppThunk, useAppDispatch} from "./store";

/* Utility function to generate the setValue reducer */
export function baseSetValue<S>() {
    return (state: S, action: PayloadAction<{ key: keyof S; value: S[keyof S] }>) => {
        const { key, value } = action.payload;
        state[key] = value;
    };
}

export const useSliceDispatch = <T>() => {
    const dispatch = useAppDispatch();
    return React.useCallback((action: T) => dispatch(action as unknown as AppThunk), [dispatch])
}




export const baseSelector = <T extends object>(sliceState: T, keys: (keyof T)[]) => {
    return () => {
        const selectedProps = {} as Partial<T>;

        keys.forEach((key) => {
            selectedProps[key] = sliceState[key];
        });

        return selectedProps;
    };
};
